<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>标题：</label>
                <el-input v-model="search_Obj.f_title" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>状态：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('act_state1')" :key="'act_state1'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="id" label="ID" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="title" label="标题" sortable="custom"></el-table-column>
                <el-table-column prop="start_time" label="开始时间" sortable="custom"></el-table-column>
                <el-table-column prop="end_time" label="结束时间" sortable="custom"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "act_state1") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看抽奖"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <UserList
            width="1200px"
            :raffle_id="model_id"
            title="参与用户"
            :isshow="usershow"
            @on-close="closeUserDialog">
        </UserList>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import UserList from "./userlist"
import listutil from "@/libs/listutil"

export default {
    name: 'raffleList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, UserList},
    data() {
        return {
            m_name: '抽奖',
            menu_id: 7800,
            list_url: "/api/admin/raffle/list",
            search_Obj: {
                f_title: '',
                f_state: '',
            },
            del_Obj:{
                url:'/api/admin/raffle/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['act_state1'],
            usershow: false,
        };
    },
    methods: {
        user(index, row) {
            this.model_id = row.id
            this.usershow = true
        },
        closeUserDialog(){
            this.usershow = false
        }
    }
};
</script>